export default __webpack_public_path__ + "static/photoelectric3-9cc8833dbde881f4a36606f0f6c1d0cd.png";